import React from 'react';
import * as styles from './index.module.scss';
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import cardLinkType from '../../lib/utils/card-link-type';

const Grid = ({ gridItems, blockIndex }) => {
    
    return(
        <div
            className={styles.grid}
        >
            {
                gridItems && gridItems.map((gridItem, index) => {
                    return(
                        <div
                            className={styles.card}
                            key={`grid-${blockIndex}-card-${index}`}
                        >
                            <a
                                className={styles.link}
                                href={`${cardLinkType(gridItem?.internal?.type)}${gridItem?.slug}`}
                            >
                                { gridItem?.featuredImages &&
                                    <GatsbyImage 
                                        alt={gridItem?.title}
                                        className={styles.image} 
                                        image={getImage(gridItem?.featuredImages[0])} 
                                    />
                                }
                                { !gridItem?.hideProductImageLabelOnDirectoryPage && gridItem?.productImageLabel &&
                                    <GatsbyImage 
                                        alt={gridItem?.title}
                                        className={styles.imageLabel} 
                                        image={getImage(gridItem?.productImageLabel)} 
                                    />
                                }
                                <div
                                    className={styles.info}
                                >
                                    <p
                                        className={styles.gridTitle}
                                    >{gridItem?.title}</p>
                                    <p>{gridItem?.excerpt?.excerpt}</p>
                                    <span
                                        className={styles.viewProduct}
                                    >
                                        View Product
                                    </span>
                                </div>
                            </a>
                        </div>
                    )
                })
            }
        </div>
    )
}

export default Grid;